import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Add Bootstrap CSS
import './Table.css';
import { useNavigate } from 'react-router-dom'; // Add this import
import { saveOrderDetails, fetchProductsFromApi } from '../api/apiClient'; // Import fetchProductsFromApi

const Table = () => {
  // const [products] = useState([]);
  const [userDetails, setUserDetails] = useState({
    name: '',
    mobile: '',
    email: '',
    state: 'Tamilnadu',
    city: '',
    address: '',
  });
  
  // const [addedProducts, setAddedProducts] = useState([]);
  const [cardProducts, setCardProducts] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('cartProducts')) || [];
    } catch {
      return [];
    }
  });
  const [groupedProducts, setGroupedProducts] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');
  // Handle image click to open modal
  const handleImageClick = (src) => {
    setModalImageSrc(src);
    setShowImageModal(true);
  };

  const handleCloseModal = () => {
    setShowImageModal(false);
    setModalImageSrc('');
  };
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
  localStorage.removeItem('emailsent');
      // Load user details from localStorage
    const savedUserDetails = JSON.parse(localStorage.getItem('userDetails')) || {
      name: '',
      mobile: '',
      email: '',
      state: 'Tamilnadu',
      city: '',
      address: '',
    };
    setUserDetails(savedUserDetails);

    fetchProductsFromApi()
      .then(data => {
        // Primary sort: Sort ALL products by product number globally first
        const sortedData = data.sort((a, b) => {
          const noA = parseInt(a.no) || 0;
          const noB = parseInt(b.no) || 0;
          return noA - noB;
        });

        // Secondary grouping: Group the number-sorted products by title
        // but maintain the number order within each group
        const groups = {};
        sortedData.forEach(prod => {
          const title = prod.title || 'Others';
          if (!groups[title]) {
            groups[title] = [];
          }
          groups[title].push(prod);
        });
        
        // Convert to array format, products already in number order
        const grouped = Object.entries(groups).map(([title, products]) => ({
          title,
          products // Maintains number-based order from initial sort
        }));
        
        // Sort groups by the lowest product number in each group
        // This ensures groups appear in the order of their first product number
        grouped.sort((a, b) => {
          const minNoA = parseInt(a.products[0]?.no) || 0;
          const minNoB = parseInt(b.products[0]?.no) || 0;
          return minNoA - minNoB;
        });
        
        setGroupedProducts(grouped);

        // Restore quantities from cartProducts
        const cart = JSON.parse(localStorage.getItem('cartProducts') || '[]');
        grouped.forEach(group => {
          group.products = group.products.map(prod => {
            const cartProd = cart.find(c => c.no === prod.no);
            if (cartProd) {
              return {
                ...prod,
                quantity: cartProd.quantity,
                total_amount: cartProd.total_amount,
                after_discount_total: cartProd.after_discount_total
              };
            }
            return {
              ...prod,
              quantity: 0,
              total_amount: 0,
              after_discount_total: 0
            };
          });
        });
        setCardProducts(cart);
      })
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  const handleQuantityChange = (groupIdx, prodIdx, value) => {
    const sanitizedValue = value === '' ? '' : Math.max(0, parseInt(value, 10) || 0);
    const updatedGroups = groupedProducts.map(group => ({
      ...group,
      products: group.products.map(prod => ({ ...prod }))
    }));

    const product = updatedGroups[groupIdx].products[prodIdx];
    product.quantity = sanitizedValue;
    const numericQty = sanitizedValue === '' ? 0 : Number(sanitizedValue);
    product.total_amount = numericQty * product.after_discount;
    product.after_discount_total = numericQty * product.after_discount;

    // Update card list: products with quantity >= 1
    const newCardProducts = updatedGroups
      .flatMap(group => group.products)
      .filter(p => Number(p.quantity) >= 1);

    setGroupedProducts(updatedGroups);
    setCardProducts(newCardProducts);
    localStorage.setItem('cartProducts', JSON.stringify(newCardProducts));
    window.dispatchEvent(new Event('cartCountUpdate')); 
    calculateTotals();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
    // Save updated user details to localStorage
    localStorage.setItem('userDetails', JSON.stringify({ ...userDetails, [name]: value }));
  };

  const calculateTotals = () => {
  let totalAmount = 0;
  let discountTotal = 0;
  cardProducts.forEach(product => {
    totalAmount += (Number(product.quantity) || 0) * (Number(product.actual_rate) || 0);
    discountTotal += (Number(product.quantity) || 0) * (Number(product.discount_amount) || 0);
  });
  const netRate = totalAmount - discountTotal;
  return { totalAmount, discountTotal, netRate, finalAmount: netRate };
};

  const handlePlaceOrder = async () => {
    const { name, mobile, state, city, address } = userDetails;
    // Save updated user details to localStorage
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
    if (!name.trim()) {
      alert('Name is required.');
      return;
    }
    if (!mobile.trim() || !/^\d{10}$/.test(mobile)) {
      alert('Valid 10-digit mobile number is required.');
      return;
    }
    if (!state.trim()) {
      alert('State is required.');
      return;
    }
    if (!city.trim()) {
      alert('City is required.');
      return;
    }
    if (!address.trim()) {
      alert('Address is required.');
      return;
    }

    // Validate minimum order amount
    if (finalAmount < 3000) {
      alert('Minimum order amount should be ₹3000. Please add more items to your cart.');
      return;
    }

    // Use cardProducts for cart and order, not filteredProducts from products
    const filteredProducts = cardProducts;

    // Save cardProducts to localStorage before navigating
    localStorage.setItem('cartProducts', JSON.stringify(filteredProducts));

    // Prepare order details
    const orderDetails = {
      userDetails: { ...userDetails },
      products: filteredProducts,
    };

    try {
      // No backend call for products, only saveOrderDetails for order
      const response = await saveOrderDetails(orderDetails);
      const { customOrderId } = response;
       localStorage.setItem('customOrderId', customOrderId);
      // Do NOT clear cart here, let Cart page read from localStorage
      navigate('/cart', {
        state: {
          products: filteredProducts,
          userDetails: { ...userDetails },
          finalAmount,
          orderId: customOrderId,
          email: userDetails.email,
          mobile: userDetails.mobile,
        },
      });
    } catch (error) {
      console.error('Error placing order:', error);
      alert('Failed to place order. Please try again.');
    }
  };

  const { totalAmount, discountTotal, netRate, finalAmount } = calculateTotals();

  return (
    <div className="table-container container mt-4">
      <style jsx>{`
        @media (max-width: 350px) {
          .table th, .table td {
            font-size: 0.55rem !important;
            padding: 0.15rem !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
          }
          /* Hide columns not needed on mobile */
          .table th:nth-child(1), .table td:nth-child(1) {
            display: none !important;
          }
          /* Image Column - Medium for small images */
          .table th:nth-child(2), .table td:nth-child(2) {
            max-width: 35px !important;
            min-width: 50px !important;
            width: 35px !important;
            text-align: center !important;
          }
          /* Actual Rate Column - Compact for mobile */
          .table th:nth-child(4), .table td:nth-child(4) {
            max-width: 45px !important;
            min-width: 45px !important;
            width: 45px !important;
            // text-align: right !important;
          }
          /* Actual Rate Column - Medium for price */
          .table th:nth-child(5), .table td:nth-child(5) {
            max-width: 45px !important;
            min-width: 45px !important;
            width: 45px !important;
            text-align: right !important;
          }
          /* After Discount Column - Medium for price */
          .table th:nth-child(6), .table td:nth-child(6) {
            max-width: 45px !important;
            min-width: 45px !important;
            width: 45px !important;
            text-align: right !important;
          }
          /* Quantity Column - Small for input */
          .table th:nth-child(7), .table td:nth-child(7) {
            max-width: 40px !important;
            min-width: 40px !important;
            width: 40px !important;
            text-align: center !important;
          }
          /* Total Amount Column - Medium for price */
          .table th:nth-child(8), .table td:nth-child(8) {
            max-width: 50px !important;
            min-width: 50px !important;
            width: 50px !important;
            text-align: right !important;
          }
          .table .tamil-name-col {
            display: none !important;
          }
          .table .discount-amount-col {
            display: none !important;
          }
          /* Product Name Column - Largest for text content */
          .table .product-name-col {
            max-width: 60px !important;
            min-width: 40px !important;
            width: 80px !important;
            word-wrap: break-word !important;
            font-size: 0.5rem !important;
            line-height: 1.1 !important;
            white-space: normal !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }
          .table img {
            width: 25px !important;
            height: 25px !important;
          }
          .table .form-control {
            font-size: 0.5rem !important;
            padding: 0.1rem !important;
            max-width: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
          }
          .title-row {
            font-size: 0.6rem !important;
            font-weight: bold !important;
          }
        }
        @media (max-width: 576px) {
          .table th, .table td {
            font-size: 0.5rem !important;
            padding: 0.1rem !important;
          }
          .table th:nth-child(1), .table td:nth-child(1) {
            display: none !important;
          }
          .table th:nth-child(1), .table td:nth-child(1) {
            max-width: 25px !important;
            min-width: 25px !important;
            width: 25px !important;
          }
          .table th:nth-child(2), .table td:nth-child(2) {
            max-width: 30px !important;
            min-width: 30px !important;
            width: 30px !important;
          }
          .table th:nth-child(4), .table td:nth-child(4) {
            max-width: 40px !important;
            min-width: 40px !important;
            width: 40px !important;
            // text-align: right !important;
          }
          .table th:nth-child(5), .table td:nth-child(5) {
            max-width: 40px !important;
            min-width: 40px !important;
            width: 40px !important;
          }
          .table th:nth-child(6), .table td:nth-child(6) {
            max-width: 40px !important;
            min-width: 40px !important;
            width: 40px !important;
          }
          .table th:nth-child(7), .table td:nth-child(7) {
            max-width: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
          }
          .table th:nth-child(8), .table td:nth-child(8) {
            max-width: 45px !important;
            min-width: 45px !important;
            width: 45px !important;
          }
          .table .product-name-col {
            max-width: 60px !important;
            min-width: 60px !important;
            width: 60px !important;
            font-size: 0.45rem !important;
            line-height: 1.0 !important;
          }
          .table img {
            width: 22px !important;
            height: 22px !important;
          }
          .table .form-control {
            font-size: 0.45rem !important;
            padding: 0.08rem !important;
            max-width: 30px !important;
            min-width: 30px !important;
            width: 30px !important;
          }
          .title-row {
            font-size: 0.55rem !important;
          }
        }
        @media (max-width: 480px) {
          .table th, .table td {
            font-size: 0.45rem !important;
            padding: 0.08rem !important;
          }
          .table th:nth-child(1), .table td:nth-child(1) {
            display: none !important;
          }
          .table th:nth-child(1), .table td:nth-child(1) {
            max-width: 20px !important;
            min-width: 20px !important;
            width: 20px !important;
          }
          .table th:nth-child(2), .table td:nth-child(2) {
            max-width: 25px !important;
            min-width: 25px !important;
            width: 25px !important;
          }
          .table th:nth-child(4), .table td:nth-child(4) {
            max-width: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
            // text-align: right !important;
          }
          .table th:nth-child(5), .table td:nth-child(5) {
            max-width: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
          }
          .table th:nth-child(6), .table td:nth-child(6) {
            max-width: 35px !important;
            min-width: 35px !important;
            width: 35px !important;
          }
          .table th:nth-child(7), .table td:nth-child(7) {
            max-width: 30px !important;
            min-width: 30px !important;
            width: 30px !important;
          }
          .table th:nth-child(8), .table td:nth-child(8) {
            max-width: 40px !important;
            min-width: 40px !important;
            width: 40px !important;
          }
          .table .product-name-col {
            max-width: 50px !important;
            min-width: 50px !important;
            width: 50px !important;
            font-size: 0.4rem !important;
            line-height: 0.9 !important;
          }
          .table img {
            width: 18px !important;
            height: 18px !important;
          }
          .table .form-control {
            font-size: 0.4rem !important;
            padding: 0.05rem !important;
            max-width: 25px !important;
            min-width: 25px !important;
            width: 25px !important;
          }
          .title-row {
            font-size: 0.5rem !important;
          }
        }
      `}</style>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>No</th>
              <th>Image</th>
              <th className="product-name-col">Product Name</th>
              <th>Actual Rate</th>
              <th className="discount-amount-col">Discount Amount</th>
              <th>After Discount</th>
              <th>Quantity</th>
              <th>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {groupedProducts.map((group, gIdx) => (
              <React.Fragment key={gIdx}>
                <tr className="table-primary">
                  <td colSpan={8} className="title-row d-none d-md-table-cell">{group.title}</td>
                  <td colSpan={5} className="title-row d-md-none">{group.title}</td>
                </tr>
                {group.products.map((product, prodIdx) => (
                  <tr key={product.no || prodIdx}>
                    <td>{product.no}</td>
                    <td>
                      <img
                        src={`/images/${product.no}.jpg`}
                        alt={`${product.no}`}
                        style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
                        onClick={() => handleImageClick(`/images/${product.no}.jpg`)}
                      />
                    </td>
      {/* Image Modal Popup */}
      {showImageModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{ position: 'relative', background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
            <button
              onClick={handleCloseModal}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: '#dc3545',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: 32,
                height: 32,
                fontSize: 18,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <img
              src={modalImageSrc}
              alt="Product Large"
              style={{ maxWidth: '80vw', maxHeight: '80vh', borderRadius: 8 }}
            />
          </div>
        </div>
      )}
                    <td className="product-name-col">{product.product_name}</td>
                    <td>₹{product.actual_rate}</td>
                    <td className="discount-amount-col">₹{product.discount_amount}</td>
                    <td>₹{product.after_discount}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={product.quantity === '' ? '' : product.quantity}
                        onChange={(e) => handleQuantityChange(gIdx, prodIdx, e.target.value)}
                        min="0"
                        placeholder=""
                        onFocus={(e) => e.target.select()}
                        style={{ minWidth: '60px' }}
                      />
                    </td>
                    <td>₹{product.after_discount_total || 0}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <div className="responsive-sections row">
        {/* User Details Section */}
        <div className="user-details col-md-6 mb-4">
          <form>
            <div className="form-group">
              <label>Name (*)</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={userDetails.name}
                onChange={handleInputChange}
                placeholder="Your Name"
              />
            </div>
            <div className="form-group">
              <label>Mobile Number (*)</label>
              <input
                type="text"
                name="mobile"
                className="form-control"
                value={userDetails.mobile}
                onChange={handleInputChange}
                placeholder="Your Mobile Number"
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={userDetails.email}
                onChange={handleInputChange}
                placeholder="Your Email"
              />
            </div>
            <div className="form-group">
              <label>State (*)</label>
              <select
                name="state"
                className="form-control"
                value={userDetails.state}
                onChange={handleInputChange}
              >
                <option value="Tamilnadu">Tamilnadu</option>
                <option value="Kerala">Kerala</option>
                <option value="Karnataka">Karnataka</option>
              </select>
            </div>
            <div className="form-group">
              <label>City (*)</label>
              <input
                type="text"
                name="city"
                className="form-control"
                value={userDetails.city}
                onChange={handleInputChange}
                placeholder="Your City"
              />
            </div>
            <div className="form-group">
              <label>Address (*)</label>
              <textarea
                name="address"
                className="form-control"
                value={userDetails.address}
                onChange={handleInputChange}
                placeholder="Your Address"
              />
            </div>
          </form>
        </div>

        {/* Totals Section */}
        <div className="totals col-md-6">
          <p>Total Amount: ₹{totalAmount.toFixed(2)}</p>
          <p>Discount Total: ₹{discountTotal.toFixed(2)}</p>
          <p>Net Rate: ₹{netRate.toFixed(2)}</p>
          <p>Packing Charge (0%): ₹0.00</p>
          <p>Overall Total: ₹{finalAmount.toFixed(2)}</p>
          {finalAmount < 3000 && (
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              Minimum order amount: ₹3000 (Add ₹{(3000 - finalAmount).toFixed(2)} more)
            </p>
          )}
          <button 
            className="btn btn-primary" 
            onClick={handlePlaceOrder}
            disabled={finalAmount < 3000}
            style={{ 
              opacity: finalAmount < 3000 ? 0.6 : 1,
              cursor: finalAmount < 3000 ? 'not-allowed' : 'pointer'
            }}
          >
            CHECKOUT
          </button>
        </div>
      </div>
      

      <div 
        className="terms-and-conditions mt-4 text-center" 
        style={{
          border: '2px solid #007bff', 
          padding: '15px', 
          borderRadius: '10px', 
          backgroundColor: '#f8f9fa'
        }}
      >
        <h5 className="text-primary" style={{ fontWeight: 'bold' }}>Terms & Conditions</h5>
        <ul className="list-unstyled" style={{ color: '#343a40', fontWeight: 'bold' }}>
          <li>All Prices Are Sivakasi Wholesale crackers online Price only</li>
          <li>Crackers will be delivered within 1 to 2 days after you successfully complete your payment</li>
          <li>For Chennai, Bangalore, Coimbatore orders will be closed 7 days before Diwali</li>
        </ul>
      </div>
    </div>
  );
};

export default Table;



